<template>
  <div id="sub-nav" v-if="step == 'PDF'">
    <div class="selection">
      <a href="/eindresultaat" class="backlink">terug naar uw resultaat</a>
    </div>
  </div>
  <div id="sub-nav" v-else>
    <div class="selection" v-if="breadcrumbSituation.length">
      <span class="label">Je hebt gekozen voor: </span>

      <span v-for="(item, index) in breadcrumbSituation" :key="item.name">
        {{ index > 0 ? ` > ` : "" }}
        <router-link :to="item.link">{{ item.name }}</router-link>
      </span>

      <span class="label" v-if="methodes"> | Methodes: </span>
      <span class="doelen" v-if="methodes">{{ methodes }}</span>
    </div>
    <div class="selection" v-else></div>
    <div class="progressbar">
      <router-link
        :to="{ name: 'startscherm' }"
        class="progressbar__item progressbar__item--menu_1"
        id="menu_1"
        >1. Jouw situatie</router-link
      >
      <router-link
        :to="{ name: 'methodes', params: { doelSlug: slug } }"
        class="progressbar__item progressbar__item--menu_2"
        id="menu_2"
        v-if="subnavstep == 'methodes'"
        >2. Methodes</router-link
      >
      <div
        class="progressbar__item progressbar__item--menu_2"
        id="menu_2"
        v-else
      >
        2. Methodes
      </div>
      <div
        class="progressbar__item progressbar__item--menu_3"
        id="menu_3"
        v-if="subnavstep == 'pdf'"
      >
        3. Jouw resultaat
      </div>
      <div
        class="progressbar__item progressbar__item--menu_3"
        id="menu_3"
        v-else
      >
        3. Jouw resultaat
      </div>
    </div>
  </div>
</template>


<script>

import storage from "../mixins/storage";

export default {
  name: "subNav",

  mixins: [ storage ],

  data() {
    return {
      slug: "",
      breadcrumbSituation: [],
    };
  },
  props: {
    methodes: String,
    step: String,
    subnavstep: String
  },

  computed: {},

  methods: {},
  created() {
    this.slug = localStorage.getItem("slug");
    this.breadcrumbSituation = this.getSituationDetails();
  },

  mounted() {},
};
</script>

